import { useEffect } from 'react';
import { useIsInBucket } from '~/library/helpers/src';

const RedirectAccountLogin = () => {
  const url = '/purchase/account?openAccountModal=signIn';

  const handleModalClosed = () => {
    const modal = document.getElementsByClassName('modal-root');
    setInterval(() => {
      if (
        modal.length === 0 &&
        !(window.location.href.indexOf('openAccountModal') > -1)
      ) {
        window.location.href = window.location.origin + url;
      }
    }, 1000);
  };

  useEffect(() => {
    handleModalClosed();

    if (window.location.href.indexOf('openAccountModal') > -1) {
      return;
    }
    window.location.href = window.location.origin + url;
  }, []);

  return null;
};

const RedirectToHome = () => {
  useEffect(() => {
    window.location.href = `${
      window.location.origin
    }/?openAccountModal=signIn&ReturnUrl=${encodeURIComponent('/purchase')}`;
  }, []);

  return null;
};

const RedirectExperiment = () => {
  const isInPurchaseHeaderBucket = useIsInBucket(
    'pp-purchase-header-dec-2023',
    'purchase-header',
    ['control']
  );

  if (isInPurchaseHeaderBucket === null) {
    return null;
  }

  return isInPurchaseHeaderBucket ? (
    <RedirectToHome />
  ) : (
    <RedirectAccountLogin />
  );
};

export default RedirectExperiment;
